import { render, staticRenderFns } from "./TenderListGeneralVersionSelector.vue?vue&type=template&id=54a29f1c&"
import script from "./TenderListGeneralVersionSelector.vue?vue&type=script&lang=js&"
export * from "./TenderListGeneralVersionSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports